<div class="loader-container" [id]="id">
  <div class="elegant-spinner">
    <svg viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="3"></circle>
    </svg>
  </div>
  <p class="loader-text">{{ loadingText }}</p>
</div>
